import { render } from "./TranslationSwitcher.vue?vue&type=template&id=7c5d1978"
import script from "./TranslationSwitcher.vue?vue&type=script&lang=js"
export * from "./TranslationSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/Users/farhad/Hemsidan/fartow-se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__